import { AppEntities } from "../../../../config/entities";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";

const DepreciationChargesList = () => {
    const fields: IListViewField[] = [
        {
            fieldName: "id",
            title: "Id",
            fieldType: "string",
        },
        {
            fieldName: "companyName",
            title: "Company",
            fieldType: "string",
        },
        {
            fieldName: "vendorName",
            title: "Vendor",
            fieldType: "string",
        },
        {
            fieldName: "totalAmount",
            title: "Total Amount",
            fieldType: "number",
            format: {
                type: "fixedPoint",
                precision: 2,
            },
        },
    ];

    return (
        <>
            <NewDocumentListView fields={fields} entity={AppEntities.DepreciationCharges} />
        </>
    );
}

export default DepreciationChargesList;